import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, NgModule, OnInit, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { forkJoin } from 'rxjs';

import { TranslateService } from '@codeandweb/ngx-translate';
import { UIRouterModule } from '@uirouter/angular';

import { TableModule } from '@app/primeng-overrides/table';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';

import { NomenclatureService } from '@app/nomenclature/nomenclature.service';
import { GlobalModule } from '@global/global.module';
import { OperationDialogComponent } from '../operation-dialog/operation-dialog';
import { OperationModificative, Texte } from '../texte.model';

import { ControlValueAccessorBase } from '@app/_helpers/control-value-accessor-base';


@Component({
    selector: 'operations-section',
    templateUrl: './operations-section.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OperationsSectionComponent),
            multi: true
        }
    ],
})
export class OperationsSectionComponent extends ControlValueAccessorBase<OperationModificative[]> implements OnInit {

    @Input() name: string;
    @Input('value') innerValue: OperationModificative[];
    @Input() required: boolean;
    @Input() readonly: boolean;

    loading: boolean = false;
    @ViewChild('tableOperations', { static: true }) table: Table;

    constructor(
        private translateService: TranslateService, 
        private dialogService: DialogService,
        private translate: TranslateService,
        private confirmationService: ConfirmationService,
        private nomenclatureService: NomenclatureService,
    ) {
        super();
    }

    ngOnInit(): void {
    }

    writeValue(value: OperationModificative[]) {
		if (value !== undefined) {
			this.innerValue = value;
            if (value === null) {
                return;
            }

            this.loading = true;

            // On charge les textes des opérations
    		const observables = this.innerValue.map((operation: OperationModificative) => this.nomenclatureService.getTexte(operation.txt_id_cible));

            forkJoin(observables)
            .subscribe((textes: Texte[]) => {
                for (let texte of textes) {
                    for (let operation of this.innerValue) {
                        if (operation.txt_id_cible == texte.txt_id) {
                            operation.txt_cible = texte;
                        }
                    }
                }
            })
            .add(() => {
                this.loading = false;
            });
		}
	}

    showOperationDialog(existingOperation?: OperationModificative) {
        const ref = this.dialogService.open(OperationDialogComponent, {
            header: this.translateService.instant(existingOperation ? 'textes.operation_modal_title' : 'textes.new_operation_modal_title', {}),
            width: '80%',
            height: '90%',
            data: {
                operation: structuredClone(existingOperation),
                readonly: !!existingOperation && (this.readonly || existingOperation.otm_date_execution)
            }
        });
        ref.onClose.subscribe((op?: OperationModificative) => {
            if (op === undefined) {
                return;
            }
            if (existingOperation) {
                Object.assign(existingOperation, op)
            }
            else {
                this.value = [...this.value, op]
                existingOperation = op;
            }
            // Chargement du texte cible
            if (! existingOperation.txt_cible) {
                this.loading = true;
                this.nomenclatureService.getTexte(op.txt_id_cible)
                .subscribe((texte: Texte) => {
                    existingOperation!.txt_cible = texte;
                })
                .add(() => {
                    this.loading = false;
                });
            }
        });
    }

    showDeletionDialog(operation: OperationModificative) {
        let message = this.translate.instant('textes.operation_deletion_confirmation', {});

        this.confirmationService.confirm({
            defaultFocus: 'reject',
            message: message,
            accept: () => {
                this.value = this.value.filter((op: OperationModificative) => op != operation)
            }
        });
    }
    
}

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule,
        GlobalModule,
        TableModule,
        AccordionModule
    ],
    exports: [OperationsSectionComponent],
    declarations: [OperationsSectionComponent]
})
export class OperationsSectionModule { }
